import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsMaterialsResponse } from '../../../../apis/academics/academics.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsMaterialsKey = 'get-academics-materials';

export type TAcademicsMaterialsParams = TPaginationParams & {
  academicYear?: string;
  grade?: string;
  classId?: string;
  // TODO: Naman - Add assignedTo student/class support to materials API
  assignedToStudentIds?: string[];
  assignedToClassIds?: string[];
};

export const useAcademicsMaterialsHook = (
  params: TAcademicsMaterialsParams,
  options?: UseQueryOptions<IAcademicsMaterialsResponse, TQueryError>
): UseQueryResult<IAcademicsMaterialsResponse, TQueryError> => {
  const { getAcademicsMaterials } = useAcademicsService();
  // TODO: Naman - Add academicYear, grade, assignedTo filters to materials API
  return useQuery<IAcademicsMaterialsResponse, TQueryError>({
    queryKey: [getAcademicsMaterialsKey, params],
    queryFn: () => getAcademicsMaterials(params),
    enabled: true,
    ...options,
  });
};
